import { render, staticRenderFns } from "./base_button.vue?vue&type=template&id=fcb514ce&scoped=true&"
import script from "./base_button.vue?vue&type=script&lang=ts&"
export * from "./base_button.vue?vue&type=script&lang=ts&"
import style0 from "./base_button.vue?vue&type=style&index=0&id=fcb514ce&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcb514ce",
  null
  
)

export default component.exports